import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideAppInitializer, ErrorHandler } from '@angular/core';
import { provideRouter, withViewTransitions } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

import { routes } from './app.routes';
import { authInterceptor } from './core/http/auth-interceptor/auth-interceptor';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { provideMarkdown } from 'ngx-markdown';
import { markdownModuleConfig } from './core/config/markdown.config';
import { initializeThemeFactory } from './core/config/theme-initializer';
import { getAppConfigProvider } from './core/config/app-config.token';
import { environment } from '../environments/environment';
import { GlobalErrorHandler } from './core/error-handler/global-error-handler';
// import { PublicRouteSyncService } from './core/services/public/public-route-sync.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideAnimationsAsync(),
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    provideRouter(routes,
      // withEnabledBlockingInitialNavigation(),
      withViewTransitions()),
    provideHttpClient(withFetch(), // enable Fetch API (fixes the warning)
    withInterceptors([authInterceptor])),
    // ngx-markdown configured with target="_blank" for links
    provideMarkdown(markdownModuleConfig),
    getAppConfigProvider(environment),
    // {
    //   provide: APP_INITIALIZER,
    //   multi: true,
    //   deps: [PublicRouteSyncService],
    //   useFactory: (routeSync: PublicRouteSyncService) => () => routeSync.start(),
    // },
    provideAppInitializer(initializeThemeFactory)
]
};
